define(function () {
    function removeEsModuleDefault (obj) { return obj && obj.__esModule && obj.default ? obj.default : obj; }
    return {
        removeEsModuleDefault,
    };
});
